import { Tag, Typography } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

const { Text } = Typography;

const BondPreviewDetail = ({
  formData,
  investorTypeOptions,
  productOptions,
  bondTypeOptions,
  custodianOptions,
  couponFrequencyOptions,
  accountOptions,
  kycStatusOptions,
  amlScreeningOptions,
  sanctionScreeningOptions,
  centralBankReportOptions,
  documentStatusOptions,
  contractRefId,
  chargeData,
  currencySymbol,
}) => {
  dayjs.extend(utc);
  const getLabelFromOptions = (options, value) =>
    options?.find((opt) => opt.value === value)?.label || value;

  const investorTypeValue =
    formData?.complianceChecks?.investorType ?? formData?.investorType;
  const bondTypeValue =
    formData?.complianceChecks?.bondType ?? formData?.bondType;
  const kycStatusValue =
    formData?.complianceChecks?.kycStatus ?? formData?.kycStatus;
  const sanctionsValue =
    formData?.complianceChecks?.sanctionsScreening ??
    formData?.sanctionsScreening;
  const cbrValue =
    formData?.complianceChecks?.centralBankReportingRequirements ??
    formData?.centralBankReportingRequirements;
  const formattedSettlementDate = dayjs
    .utc(formData?.settlementDate)
    .format("dddd, MMMM D, YYYY");

  const formatFullDate = (date) => {
    if (!date) return "-";
    try {
      return new Date(date).toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return "-";
    }
  };

  const data = [
    {
      section: "Investor Information",
      items: [
        {
          name: "Investor Name",
          value:
            formData?.investorInformation?.investorName ||
            formData?.investorName
              ? formData?.investorInformation?.investorName ||
                formData?.investorName
              : "-",
        },
        {
          name: "Investor Type",
          // value:
          //   formData?.investorInformation?.investorType ||
          //   formData?.investorType
          //     ? getLabelFromOptions(
          //         investorTypeOptions,
          //         formData?.investorInformation?.investorType
          //       )
          //     : "-",
          value:
            investorTypeValue !== undefined && investorTypeValue !== null
              ? getLabelFromOptions(investorTypeOptions, investorTypeValue)
              : "-",
          isTag: true,
        },
        {
          name: "Contact Address",
          value:
            formData?.investorInformation?.address || formData?.address
              ? formData?.investorInformation?.address || formData?.address
              : "-",
        },
        {
          name: "City",
          value:
            formData?.investorInformation?.city || formData?.city
              ? formData?.investorInformation?.city || formData?.city
              : "-",
        },
        {
          name: "Phone Number",
          value:
            formData?.investorInformation?.phoneNumber || formData?.phoneNumber
              ? formData?.investorInformation?.phoneNumber ||
                formData?.phoneNumber
              : "-",
        },
        {
          name: "Email",
          value:
            formData?.investorInformation?.email || formData?.email
              ? formData?.investorInformation?.email || formData?.email
              : "-",
        },
        {
          name: "BVN",
          value:
            formData?.investorInformation?.bvn || formData?.bvn
              ? formData?.investorInformation?.bvn || formData?.bvn
              : "-",
        },
        {
          name: "TIN",
          value:
            formData?.investorInformation?.tin || formData?.tin
              ? formData?.investorInformation?.tin || formData?.tin
              : "-",
        },
      ],
    },
    {
      section: "Bond Details",
      items: [
        {
          name: "Bond Product Name",
          value: formData
            ? getLabelFromOptions(
                productOptions,
                formData?.bondDetails?.productName ?? formData?.productName
              )
            : "-",
          isTag: true,
        },
        {
          name: "Deal Initation Date",
          value: formData
            ? formatFullDate(
                formData?.bondDetails?.initiationDate ??
                  formData?.initiationDate
              )
            : "-",
        },
        {
          name: "Branch Code",
          value: formData
            ? formData?.bondDetails?.branchCode ?? formData?.branchCode
            : "-",
        },
        {
          name: "Initiated By",
          value: formData
            ? formData?.bondDetails?.initiatedBy ?? formData?.initiatedBy
            : "-",
        },
        {
          name: "User ID",
          value: formData
            ? formData?.bondDetails?.userID ?? formData?.userID
            : "-",
        },
        {
          name: "Bond Type",
          // value: formData?.bondDetails?.bondType
          //   ? getLabelFromOptions(
          //       bondTypeOptions,
          //       formData.bondDetails.bondType
          //     )
          //   : "-",
          value:
            bondTypeValue !== undefined && bondTypeValue !== null
              ? getLabelFromOptions(bondTypeOptions, bondTypeValue)
              : "-",
          isTag: true,
        },
        {
          name: "Issuer",
          value: formData
            ? formData?.bondDetails?.issuer ?? formData?.issuer
            : "-",
        },
        {
          name: "Issue Date",
          value: formData
            ? formatFullDate(
                formData?.bondDetails?.issueDate ?? formData?.issueDate
              )
            : "-",
        },
        {
          name: "Maturity Date",
          value: formData
            ? formatFullDate(
                formData?.bondDetails?.maturityDate ?? formData?.maturityDate
              )
            : "-",
        },
        {
          name: "Tenor",
          value: formData
            ? formData?.bondDetails?.tenor ?? formData?.tenor
            : "-",
        },
        {
          name: "Coupon Rate",
          value: formData
            ? formData?.bondDetails?.couponRate ?? formData?.couponRate
            : "-",
        },
        {
          name: "Coupon Payment Frequency",
          value: formData
            ? getLabelFromOptions(
                couponFrequencyOptions,
                formData?.bondDetails?.couponFrequency ??
                  formData?.couponFrequency
              )
            : "-",
        },
        {
          name: "Currency",
          value: formData
            ? formData?.bondDetails?.currency ?? formData?.currency
            : "-",
        },
        {
          name: "Custodian",
          value: formData
            ? getLabelFromOptions(
                custodianOptions,
                formData?.bondDetails?.custodian ?? formData?.custodian
              )
            : "-",
          isTag: true,
        },
      ],
    },
    {
      section: "Tax & Charges",
      items: [
        {
          isInlineGroup: true,
          group: [
            {
              name: "Tax Group",
              isTagGroup: true,
              fields: [
                {
                  value: chargeData?.allowTax ?? "-",
                  isTag: true,
                },
                {
                  value: chargeData?.taxGroup?.name || "-",
                  isTag: true,
                },
                {
                  value: chargeData?.taxGroup?.taxAssociations[0]?.taxComponent
                    ?.percentage
                    ? `%${chargeData?.taxGroup?.taxAssociations[0]?.taxComponent?.percentage?.toLocaleString()}`
                    : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Processing Charges",
              isTagGroup: true,
              fields: [
                {
                  value: chargeData?.setupCharges ?? "-",
                  isTag: true,
                },
                {
                  value: chargeData?.setupCharge?.name || "-",
                  isTag: true,
                },
                {
                  value: chargeData?.setupCharge?.amount
                    ? `${currencySymbol}${chargeData?.setupCharge?.amount?.toLocaleString()}`
                    : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Redemption Charges",
              isTagGroup: true,
              fields: [
                {
                  value: chargeData?.redemptionCharges ?? "-",
                  isTag: true,
                },
                {
                  value: chargeData?.redemptionCharge?.name || "-",
                  isTag: true,
                },
                {
                  value: chargeData?.redemptionCharge?.amount
                    ? `${currencySymbol}${chargeData?.redemptionCharge?.amount?.toLocaleString()}`
                    : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Stamp Duty Charges",
              isTagGroup: true,
              fields: [
                {
                  value: chargeData?.transferCharges ?? "-",
                  isTag: true,
                },
                {
                  value: chargeData?.transferCharge?.name || "-",
                  isTag: true,
                },
                {
                  value: chargeData?.transferCharge?.amount
                    ? `${currencySymbol}${chargeData?.transferCharge?.amount?.toLocaleString()}`
                    : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Brokerage/Agent Commission",
              isTagGroup: true,
              fields: [
                {
                  value: chargeData?.allowBrokerage ?? "-",
                  isTag: true,
                },
                {
                  value: chargeData?.commission?.name || "-",
                  isTag: true,
                },
                {
                  value: chargeData?.commission?.amount
                    ? `${currencySymbol}${chargeData?.commission?.amount?.toLocaleString()}`
                    : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      section: "Investment Details",
      items: [
        {
          name: "Investor Amount",
          value:
            formData?.investmentDetails?.investorAmount ||
            formData?.investorAmount
              ? formData.investmentDetails?.investorAmount?.toLocaleString() ||
                formData?.investorAmount?.toLocaleString()
              : "-",
        },
        {
          name: "Purchase Price",
          value:
            formData?.investmentDetails?.purchasePrice ||
            formData?.purchasePrice
              ? formData?.investmentDetails?.purchasePrice.toLocaleString() ||
                formData?.purchasePrice?.toLocaleString()
              : "-",
        },
        {
          name: "Number of Units Purchased",
          value:
            formData?.investmentDetails?.numberOfUnitsPurchased ||
            formData?.numberOfUnitsPurchased
              ? formData?.investmentDetails?.numberOfUnitsPurchased?.toLocaleString() ||
                formData?.numberOfUnitsPurchased
              : "-",
        },
        {
          name: "Total Consideration",
          value:
            formData?.investmentDetails?.totalConsideration ||
            formData?.totalConsideration
              ? formData?.investmentDetails?.totalConsideration.toLocaleString() ||
                formData?.totalConsideration?.toLocaleString()
              : "-",
        },
        {
          name: "Settlement Date",
          value: formData?.investmentDetails?.settlementDate
            ? formatFullDate(formData?.investmentDetails?.settlementDate)
            : formData?.settlementDate
            ? formattedSettlementDate
            : "-",
        },
        {
          name: "Settlement Account Number",
          value:
            formData?.investmentDetails?.settlementAccountNumber ||
            formData?.settlementAccountNumber
              ? getLabelFromOptions(
                  accountOptions,
                  formData?.investmentDetails?.settlementAccountNumber ||
                    formData?.settlementAccountNumber
                )
              : "-",
          isTag: true,
        },
      ],
    },
    {
      section: "Compliance Checks",
      items: [
        {
          name: "KYC Status",
          // value:
          //   formData?.complianceChecks?.kycStatus ?? formData?.kycStatus
          //     ? getLabelFromOptions(
          //         kycStatusOptions,
          //         formData?.complianceChecks?.kycStatus || formData?.kycStatus
          //       )
          //     : "-",

          value:
            kycStatusValue !== undefined && kycStatusValue !== null
              ? getLabelFromOptions(kycStatusOptions, kycStatusValue)
              : "-",
          isTag: true,
        },
        {
          name: "AML Screening",
          value:
            formData?.complianceChecks?.amlScreening ?? formData?.amlScreening
              ? getLabelFromOptions(
                  amlScreeningOptions,
                  formData?.complianceChecks?.amlScreening ||
                    formData?.amlScreening
                )
              : "-",
          isTag: true,
        },
        {
          name: "Sanctions Screening",
          // value:
          //   formData?.complianceChecks?.sanctionsScreening ||
          //   formData?.sanctionsScreening
          //     ? getLabelFromOptions(
          //         sanctionScreeningOptions,
          //         formData?.complianceChecks?.sanctionsScreening ||
          //           formData?.sanctionsScreening
          //       )
          //     : "-",
          value:
            sanctionsValue !== undefined && sanctionsValue !== null
              ? getLabelFromOptions(sanctionScreeningOptions, sanctionsValue)
              : "-",
          isTag: true,
        },
        {
          name: "Central Bank Reporting Requirements",
          // value:
          //   formData?.complianceChecks?.centralBankReportingRequirements ||
          //   formData?.centralBankReportingRequirements
          //     ? getLabelFromOptions(
          //         centralBankReportOptions,
          //         formData?.complianceChecks
          //           ?.centralBankReportingRequirements ||
          //           formData?.centralBankReportingRequirements
          //       )
          //     : "-",
          value:
            cbrValue !== undefined && cbrValue !== null
              ? getLabelFromOptions(centralBankReportOptions, cbrValue)
              : "-",
          isTag: true,
        },
      ],
    },
    {
      section: "Document Requirements",
      items: [
        {
          name: "Investor's Application Form",
          value:
            formData?.documentRequirements?.investorApplicationForm ||
            formData?.investorApplicationForm
              ? getLabelFromOptions(
                  documentStatusOptions,
                  formData?.documentRequirements?.investorApplicationForm ||
                    formData?.investorApplicationForm
                )
              : "-",
          isTag: true,
        },
        {
          name: "Executed Bond Purchase Agreement",
          value:
            formData?.documentRequirements?.executedBondPurchaseAgreement ||
            formData?.executedBondPurchaseAgreement
              ? getLabelFromOptions(
                  documentStatusOptions,
                  formData?.documentRequirements
                    ?.executedBondPurchaseAgreement ||
                    formData?.executedBondPurchaseAgreement
                )
              : "-",
          isTag: true,
        },
        {
          name: "Identification Documents",
          value:
            formData?.documentRequirements?.identificationDocuments ||
            formData?.identificationDocuments
              ? getLabelFromOptions(
                  documentStatusOptions,
                  formData?.documentRequirements?.identificationDocuments ||
                    formData?.identificationDocuments
                )
              : "-",
          isTag: true,
        },
        {
          name: "Corporate Resolution",
          value:
            formData?.documentRequirements?.corporateResolution ||
            formData?.corporateResolution
              ? getLabelFromOptions(
                  documentStatusOptions,
                  formData?.documentRequirements?.corporateResolution ||
                    formData?.corporateResolution
                )
              : "-",
          isTag: true,
        },
        {
          name: "Tax Clearance Certificate",
          value:
            formData?.documentRequirements?.taxClearanceCertificate ||
            formData?.taxClearanceCertificate
              ? getLabelFromOptions(
                  documentStatusOptions,
                  formData?.documentRequirements?.taxClearanceCertificate ||
                    formData?.taxClearanceCertificate
                )
              : "-",
          isTag: true,
        },
      ],
    },
  ];

  const renderTag = (value) => {
    if (value === true) {
      return (
        <Tag
          style={{
            backgroundColor: "#ECFDF3",
            border: "1px solid #ABEFC6",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#067647",
              fontWeight: 600,
            }}
          >
            Yes
          </Text>
        </Tag>
      );
    }

    if (value === false) {
      return (
        <Tag
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "16px",
            padding: "2px 12px",
            textTransform: "capitalize",
          }}
        >
          <Text
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            No
          </Text>
        </Tag>
      );
    }

    if (
      value === "-" ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return <Text style={{ fontWeight: 500, color: "#6b7280" }}>-</Text>;
    }

    // Default tag for select fields
    return (
      <Tag
        style={{
          backgroundColor: "#FDF4FF",
          border: "1px solid #F6D0FE",
          borderRadius: "16px",
          padding: "2px 12px",
        }}
      >
        <Text
          style={{
            textTransform: "capitalize",
            color: "#9F1AB1",
            fontWeight: 600,
          }}
        >
          {value}
        </Text>
      </Tag>
    );
  };

  const renderRow = (item, index, section) => {
    const isLastItem = index === (data[section]?.items?.length || 0) - 1;

    if (item.isInlineGroup && Array.isArray(item.group)) {
      return (
        <div
          key={`inline-group-${section}-${index}`}
          style={{
            display: "flex",
            borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
          }}
        >
          {item.group.map((fieldGroup, groupIndex) => (
            <>
              <div
                key={`group-${groupIndex}`}
                style={{
                  width: "50%",
                  backgroundColor: "#f9f9f9",
                  padding: "16px 24px",
                  fontWeight: "500",
                  borderRight: "1px solid #f0f0f0",
                }}
              >
                {fieldGroup.name}
              </div>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  padding: "16px 24px",
                  width: "50%",
                  backgroundColor: "#fff",
                }}
              >
                {fieldGroup.fields.map((subField) => (
                  <div
                    key={subField.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: 500,
                    }}
                  >
                    {subField.isTag ? (
                      renderTag(subField.value)
                    ) : (
                      <span>
                        {" "}
                        {subField.name?.toLowerCase() === "email"
                          ? subField.value?.toLowerCase()
                          : subField.value}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </>
          ))}
        </div>
      );
    }

    return (
      <div
        key={item.key || item.name}
        style={{
          display: "flex",
          borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#f9f9f9",
            fontWeight: "500",
            borderRight: "1px solid #f0f0f0",
          }}
        >
          {item.name}
        </div>
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#fff",
          }}
        >
          {item.isTag ? (
            renderTag(item.value)
          ) : (
            <Text style={{ textTransform: "capitalize", fontWeight: 600 }}>
              {item.value}
            </Text>
          )}
        </div>
      </div>
    );
  };

  return (
    <div style={{ width: "100%" }}>
      <h1
        style={{
          fontSize: "24px",
          fontWeight: "700",
          margin: 0,
          marginBottom: "24px",
        }}
      >
        Preview
      </h1>

      {contractRefId && (
        <h2 style={{ fontSize: "16px" }}>Contract ID: {contractRefId}</h2>
      )}

      {data.map((section, sectionIndex) => (
        <div key={section.section}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              marginBottom: "16px",
            }}
          >
            {section.section}
          </h2>
          <div
            style={{
              border: "1px solid #f0f0f0",
              borderRadius: "8px",
              marginBottom: "24px",
            }}
          >
            {section.items.map((item, index) =>
              renderRow(item, index, sectionIndex)
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default BondPreviewDetail;
